exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "dl._388RrgXNXBOttU7qBT61wl{margin:0;min-height:22px}dl._388RrgXNXBOttU7qBT61wl dt{font-weight:bold;float:left;width:160px;overflow:hidden;text-align:right;text-overflow:ellipsis;white-space:nowrap}dl._388RrgXNXBOttU7qBT61wl dd{margin-left:180px}\n", ""]);

// Exports
exports.locals = {
	"infoRow": "_388RrgXNXBOttU7qBT61wl"
};